import { render, staticRenderFns } from "./Sucesso.vue?vue&type=template&id=5e2a2a75&scoped=true"
import script from "./Sucesso.vue?vue&type=script&lang=js"
export * from "./Sucesso.vue?vue&type=script&lang=js"
import style0 from "./Sucesso.vue?vue&type=style&index=0&id=5e2a2a75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2a2a75",
  null
  
)

export default component.exports